// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TileCanvas__tileCanvasParent___zqXcJ{z-index:1}.TileCanvas__tileCanvas___1OFxD,.TileCanvas__tileCanvasParent___zqXcJ{height:100%;width:100%}", ""]);
// Exports
exports.locals = {
	"tileCanvasParent": "TileCanvas__tileCanvasParent___zqXcJ",
	"tileCanvas": "TileCanvas__tileCanvas___1OFxD"
};
module.exports = exports;
